import * as resource from 'api/resourceApi';

// Fonction pour récupérer les couleurs des boutons
export async function getColors() {
    try {
        const response = await resource.getColors();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des couleurs des boutons :', error);
        throw new Error('Erreur lors de la récupération des couleurs des boutons.');
    }
};

// Fonction pour récupérer les ressources
export async function getResources() {
    try {
        const response = await resource.getResources();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des ressources :', error);
        throw new Error('Erreur lors de la récupération des ressources.');
    }
};

// Fonction pour insérer ou mettre à jour une ressource
export async function upsertResource(data) {
    try {
        const response = await resource.upsertResource(data);
        return response;
    } catch (error) {
        console.error('Erreur lors de l\'insertion ou de la mise à jour de la ressource :', error);
        throw new Error('Erreur lors de l\'insertion ou de la mise à jour de la ressource.');
    }
};

// Fonction pour supprimer une ressource
export async function deleteResource(id) {
    try {
        const response = await resource.deleteResource(id);
        return response;
    } catch (error) {
        console.error('Erreur lors de la suppression de la ressource :', error);
        throw new Error('Erreur lors de la suppression de la ressource.');
    }
};